import { j as e } from "../../../_virtual/jsx-runtime.js";
import { useState as p, useEffect as g } from "react";
import l from "styled-components";
import h from "../Input.js";
import { Form as n, Flex as y, Checkbox as M, message as f } from "antd";
import I from "../Button.js";
import j from "./comps/Success.js";
import { useIsMobile as v } from "../../hook/useIsMobile.js";
import { login as R } from "../../api/auth/index.js";
import r from "localforage";
import { StorageKeyEnum as s } from "../../const/StorageKeyEnum.js";
import { sleep as _ } from "../../utils/sleep.js";
import { useNavigate as F } from "react-router-dom";
function W(t) {
  const [a] = n.useForm(), [b, k] = p(!1), [c, u] = p(!1), [x, m] = p(!1), d = v(), w = F();
  g(() => {
    r.removeItem(s.ADMIN_TOKEN), r.removeItem(s.ADMIN_REFRESH_TOKEN), r.removeItem(s.ADMIN_TOKEN_EXPIRE_TIME);
  }, []), g(() => {
    r.getItem(s.ADMIN_REMEMBER_ME).then((o) => {
      o && (u(!0), a.setFieldsValue(o));
    });
  }, []);
  const E = async () => {
    if (await a.validateFields()) {
      m(!0);
      try {
        const o = a.getFieldsValue(), i = await R({ email: o.email, password: o.password });
        if (i.code != 0 || !i.data) {
          f.error(i.message), m(!1);
          return;
        }
        f.success("login success"), c ? r.setItem(s.ADMIN_REMEMBER_ME, {
          email: o.email,
          password: o.password
        }) : r.removeItem(s.ADMIN_REMEMBER_ME), await t.onSuccess(i.data.user), w("/", { replace: !0 });
      } catch {
        f.error("login failed"), m(!1);
      }
    }
  };
  return b ? /* @__PURE__ */ e.jsx(j, { title: "Login Success", description: "You have successfully logged in to your account." }) : /* @__PURE__ */ e.jsxs(N, { children: [
    /* @__PURE__ */ e.jsx("div", { children: t.logo }),
    /* @__PURE__ */ e.jsx(P, { children: "Welcome to Ocash" }),
    /* @__PURE__ */ e.jsxs(n, { form: a, style: { width: "100%" }, onFinish: E, children: [
      /* @__PURE__ */ e.jsx(
        n.Item,
        {
          name: "email",
          rules: [
            { required: !0, message: "Please input your email!" },
            {
              type: "email",
              message: "Please enter the correct email address."
            }
          ],
          children: /* @__PURE__ */ e.jsx(h, { placeholder: "Enter email address", label: "Email", style: { width: d ? "100%" : 392 }, autoComplete: "off" })
        }
      ),
      /* @__PURE__ */ e.jsx(
        n.Item,
        {
          name: "password",
          rules: [
            { required: !0, message: "Please input your password!" },
            {
              pattern: /^[a-zA-Z0-9]{8,25}$/,
              message: "Please enter the correct password!"
            }
          ],
          children: /* @__PURE__ */ e.jsx(
            h,
            {
              placeholder: "Use 8-25 English letters and numbers",
              label: "Password",
              type: "password",
              variant: "password",
              autoComplete: "current-password",
              onBeforeShowPassword: async () => (c && await _(100), !0),
              style: { width: d.isMobile ? "100%" : 392 }
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsxs(y, { justify: "space-between", children: [
        /* @__PURE__ */ e.jsx(
          M,
          {
            checked: c,
            onChange: (o) => {
              u(o.target.checked);
            },
            children: "Remember me"
          }
        ),
        /* @__PURE__ */ e.jsx(A, { href: "/forgot-password", children: "Forgot password?" })
      ] }),
      /* @__PURE__ */ e.jsx(S, { htmlType: "submit", type: "primary", loading: x, $isMobile: d.isMobile, children: "Log in" })
    ] })
  ] });
}
const N = l.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, P = l.div`
  color: var(--color-text);
  font-family: 'Poppins';
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 32px;
`, A = l.a`
  color: var(--color-text);
  font-family: 'Poppins';
  font-size: 14px;
  font-weight: 400;
`, S = l(I)`
  && {
    width: ${({ $isMobile: t }) => t ? "100%" : "392px"};
    height: 52px;
    margin-top: 32px;
    border-radius: 0;
    border: 1px solid rgba(20, 20, 19, 0.18);
    background: var(--bg-primary);
    color: #fff;
    box-shadow: none;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.2px;
  }

  &&:hover,
  &&:focus {
    background: var(--bg-primary-hover);
    border-color: rgba(20, 20, 19, 0.24);
    color: #fff;
  }

  &&:disabled {
    background: rgba(20, 20, 19, 0.4);
    border-color: rgba(20, 20, 19, 0.1);
    color: rgba(255, 255, 255, 0.6);
  }
`;
export {
  W as default
};
